<template>
    <div class="details" @click.self="isReplys = false">
        <div class="header">
            <h1 style="margin-bottom: 10px;">{{ detail.descr }}</h1>
        </div>
        <div class="nav">
            <div class="nav_top">
                贡献人* <span style="color: #4991ff;">{{ detail.createBy }}{{ detail.customerName ? "/" : "" }}{{
        detail.customerName }}</span>
                ，#工单类型# {{
        detail.workTypeName }}
            </div>
            <div class="nav_bottom">
                {{ detail.createTime }}
            </div>
        </div>
        <div class="main-center">
            <div class="main-box">
                <p style="font-size: 18px; color: #000;margin-top: 10px;" v-html="detail.recommendation">
                </p>
                <div v-if="detail.accessory">
                    <span style="font-size: 16px;">附件：</span>
                    <p style="font-size: 16px; color: #000; padding-left: 32px;margin-top: 10px;"><a
                            style='margin-left:20px' :href="IMAGE_HOST + detail.accessory" target="_blank">查看文件<svg
                                t="1686795127586" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                xmlns="http://www.w3.org/2000/svg" p-id="7800" width="20" height="20">
                                <path
                                    d="M848.8576 199.1936H415.7568c0-26.5728-21.5424-48.128-48.128-48.128H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128V343.5648c0 26.5984 21.5424 48.1408 48.128 48.1408h673.728c26.5728 0 48.128-21.5424 48.128-48.1408v-96.2432c-0.0128-26.5856-21.5552-48.128-48.1408-48.128z"
                                    fill="#CCA352" p-id="7801"></path>
                                <path
                                    d="M800.7424 247.3088H223.2576c-26.5728 0-48.128 21.5424-48.128 48.128v48.128c0 26.5984 21.5424 48.1408 48.128 48.1408h577.472c26.5728 0 48.128-21.5424 48.128-48.1408v-48.128c0-26.5728-21.5424-48.128-48.1152-48.128z"
                                    fill="#FFFFFF" p-id="7802"></path>
                                <path
                                    d="M848.8576 295.4368H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128v481.2544c0 26.5472 21.5424 48.128 48.128 48.128h673.728c26.5728 0 48.128-21.568 48.128-48.128V343.552c-0.0128-26.5728-21.5552-48.1152-48.1408-48.1152z"
                                    fill="#FFCC66" p-id="7803"></path>
                            </svg></a>
                    </p>
                </div>
                <!-- <div class="main-bottom">
                    <div class="m-b-box">
                        <div class="m-b-name">创建者：{{ detail.createBy }}</div>
                        <div class="m-b-time">创建时间：{{ detail.createTime }}</div>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="upvote-box" v-if="this.types != 1">
            <div class="upvote" @click="upvote()">
                <Icon :type="upvoteState ? 'md-heart' : 'md-heart-outline'" size="16" />
                {{ detail.giveNum }}人点赞
            </div>
            <div class="page-view">
                <Icon type="md-eye" size="16" />
                {{ detail.visitNum }}人浏览
            </div>
            <div class="comment">
                <Icon type="md-text" size="16" />
                {{ detail.messageNum }}人评论
            </div>
        </div>
        <div class="comment-box" v-if="this.types != 1">
            <div class="comment-text">
                <Input v-model="value2" type="textarea" :rows="4" placeholder="请输入回复内容" />
                <Button type="default" style="margin-top: 10px; width: 140px; height: 40px;"
                    @click="onComment()">评论</Button>
            </div>
            <div class="comment-title">
                评论（{{ commentList.length }}）
            </div>
            <div class="comment-list" v-for="item in commentList" :key="item.id">
                <div class="comment-item">
                    <div class="c-i-left">
                        <img :src="item.favatar ? item.favatar.includes('http') ? item.favatar : (IMAGE_HOST + item.favatar) : ''
        " alt="">
                    </div>
                    <div class="c-i-right">
                        <div style="display: flex; justify-content: space-between; width: 100%;">
                            <div class="right-top">
                                <div class="r-t-name">{{ item.fname }}</div>
                                <div class="r-t-time">{{ item.time }}</div>
                            </div>
                            <div class="right-reply" @click.stop="onIsReply(item)">回复</div>
                        </div>
                        <div class="c-i-text">
                            {{ item.message }}
                        </div>
                    </div>
                </div>
                <div class="comment-reply" v-if="isReply == item.id && isReplys">
                    <Input v-model="value3" type="textarea" :rows="4" placeholder="请输入回复内容" />
                    <Button type="default" style="margin-top: 10px; width: 140px; height: 40px;"
                        @click="onCommentReply(item)">评论</Button>
                </div>
                <div class="comment-list-box">
                    <div>
                        <div class="comment-list" v-for=" item  in  item.childrenList " :key="item.id">
                            <div class="comment-item">
                                <div class="c-i-left">
                                    <img :src="item.favatar ? item.favatar.includes('http') ? item.favatar : (IMAGE_HOST + item.favatar) : ''" alt="">
                                </div>
                                <div class="c-i-right">
                                    <div style="display: flex; justify-content: space-between; width: 100%;">
                                        <div class="right-top">
                                            <div class="r-t-name">{{ item.fname }}</div>
                                            <div class="r-t-time">{{ item.time }}</div>
                                        </div>
                                        <!-- <div class="right-reply" @click.stop="onIsReply(item)">回复</div> -->
                                    </div>
                                    <div class="c-i-text">
                                        {{ item.message }}
                                    </div>
                                </div>
                            </div>
                            <div class="comment-reply" v-if="isReply == item.id && isReplys">
                                <Input v-model="value3" type="textarea" :rows="4" placeholder="请输入回复内容" />
                                <Button type="default" style="margin-top: 10px; width: 140px; height: 40px;"
                                    @click="onCommentReply(item)">评论</Button>
                            </div>
                            <div class="comment-list-box">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Icon } from 'view-design';
import { IMAGE_HOST } from "../../../config";

export default {
    data() {
        return {
            id: '',
            detail: {},
            value2: '',
            value3: '',
            isReply: '',
            types: '',
            isReplys: true,
            commentList: [],
            upvoteState: false,
            IMAGE_HOST: IMAGE_HOST
        };
    },
    props: ["row", "type"],
    created() {
        this.id = this.$props.row.id;
        this.types = this.$props.type
        this.useful();
        if (this.types != 1) {
            this.comment()
            this.browse()
            this.upvoteInfo()
        }
    },
    methods: {
        // 当前知识库信息
        async useful() {
            let q = {};
            let res = await $utils.api.load(`/admin/system/common/${this.id}`, q);
            // console.log(res);
            if (res.code == 200) {
                this.detail = res.data;
            }
        },
        // 点赞和取消点赞
        async upvote() {
            let q = {
                id: this.id,
                type: ''
                // maintainerId
            };
            if (this.upvoteState) {
                q.type = 'give_del'
            } else {
                q.type = 'give'
            }
            let res = await $utils.api.load(`/admin/system/common/changeNum`, q, 'get');
            if (res.code == 200) {
                this.useful()
                this.upvoteInfo()
            }
            console.log(res);
        },
        // 是否已点赞
        async upvoteInfo() {
            let q = {}
            let res = await $utils.api.load(`/admin/system/workGive/${this.id}`, q)
            // console.log(res);
            if (res.code == 200) {
                this.upvoteState = res.data ? true : false
            }
        },
        // 获取浏览量
        async browse() {
            let q = {
                id: this.id,
                type: 'visit'
            };
            let res = await $utils.api.load(`/admin/system/common/changeNum`, q, 'get');
            if (res.code == 200) {
                this.useful();
            }
        },
        // 获取评论列表
        async comment() {
            let q = {
                workCommonId: this.id,
            }
            let res = await $utils.api.load('/admin/system/workMessage/cascade', q)
            this.commentList = res.rows
        },
        // 评论
        async onComment() {
            let q = {
                workCommonId: this.id,
                message: this.value2,
                // replyId:
            }
            let res = await $utils.api.load('/admin/system/workMessage', q, 'post')
            // console.log(res);
            if (res.code == 200) {
                this.comment()
                this.useful();
                this.value2 = ''
            }
        },
        onIsReply(item) {
            // console.log(item);
            this.isReplys = true
            this.isReply = item.id
        },
        // 评论
        async onCommentReply(item) {
            let q = {
                workCommonId: this.id,
                pid: item.fid,
                floorId: item.id,
                message: this.value3
            }
            let res = await $utils.api.load('/admin/system/workMessage', q, 'post')
            if (res.code == 200) {
                this.comment()
                this.useful();
                this.isReplys = false
                this.value3 = ''
            }
            // console.log(res);
        }
    },
    components: { Icon }
}
</script>

<style lang="less" scoped>
.details {
    width: 100%;
    margin: 0 auto;
    min-height: 100vh;
    // padding: 0 40px;
    padding-bottom: 200px;
    // box-shadow: 20px 0 15px -20px #aaa,
    //     -20px 0 15px -20px #aaa;
    padding-top: 40px;

    .header {
        text-align: center;
        margin-bottom: 60px;
    }

    .nav {
        padding: 0 100px;
        margin-bottom: 20px;

        .nav_top {
            font-size: 14px;
            margin-bottom: 10px;
        }

        .nav_bottom {
            font-size: 14px;
        }
    }

    .main-center {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .main-box {
            width: 100%;
            padding: 0 100px;
        }

        .main-bottom {
            display: flex;
            flex-direction: column;
            align-items: end;
            margin-top: 60px;
            color: #000;
        }
    }

    .upvote-box {
        width: 100%;
        display: flex;
        justify-content: right;
        padding: 80px 100px;
        font-size: 14px;

        .upvote {
            margin-right: 20px;
        }

        .page-view {
            margin-right: 20px;
        }
    }

    .comment-box {
        padding: 0 100px;

        .comment-text {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
        }

        .comment-title {
            font-size: 18px;
            font-weight: 600;
            color: #666;
            margin-bottom: 20px;
        }

        .comment-list {
            margin-bottom: 20px;

            .comment-reply {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
            }

            .comment-list-box {
                width: 100%;
                display: flex;
                align-items: flex-end;
                flex-direction: column;

                >div {
                    width: 95%;
                }


            }
        }

        .comment-item {
            display: flex;
            margin-bottom: 10px;
            width: 100%;

            .c-i-left {
                margin-right: 20px;

                img {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                }
            }

            .c-i-right {
                width: 100%;

                .right-top {
                    display: flex;
                    margin-bottom: 6px;

                    .r-t-name {
                        margin-right: 10px;
                        color: #2a75ed;
                    }

                    .r-t-time {
                        color: #999;
                    }
                }

                .right-reply {
                    color: #2a75ed;
                }

                .c-i-text {
                    font-size: 16px;
                    color: #000;
                }
            }
        }
    }
}
</style>